import request from '@/helpers/request'
import Vue from 'vue'
// import store from '@/store';
// import CityFactory from '@/factory/city';
// import UnitFactory from '@/factory/unit';
// import ServerValidationError from '@/helpers/ServerValidationError';
// import full_name from '@/helpers/full_name';
// import router from '@/router';

import { GET_BOOKING_SOURCES } from '@/store/action_types'

import { SET_BOOKING_SOURCES, SET_BOOKING_SOURCE_FILTERS } from '@/store/mutation_types'

export default {
  [GET_BOOKING_SOURCES]: ({ commit, state }, { params = {}, formatter, callback }) => {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.bookingSources.all}`,
      {
        params: params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        let items = data.items

        if (formatter) {
          items = formatter(items)
        }

        commit(SET_BOOKING_SOURCES, state.bookingSources.concat(items))
        commit(SET_BOOKING_SOURCE_FILTERS, data.filters)

        callback ? callback(state.bookingSources) : null
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_BOOKING_SOURCES: ({ commit, state }) => {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.bookingSources.all}`, true).then(
      response => {
        const data = response.data.data
        commit('SET_BOOKING_SOURCES', data.items)
      },
    )
  },
}
